import ORDER_TABS_CONFIG from "./MyOrdersConfig";
import TICKET_TABS_CONFIG from "./MyTicketsConfig";

const TAB_DISPLAY_CONFIG = {
  Orders: ORDER_TABS_CONFIG,
  Tickets: TICKET_TABS_CONFIG
};

export default TAB_DISPLAY_CONFIG;
